import i18n from 'i18n';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { TlsProfile } from 'data/tlsProfile/tlsProfile.types';
import authenticationValueGetter from './utils/tlsProfileTemplateValueGetter';

export enum DistributorMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newTlsProfile: TlsProfile = {
  id: '',
  name: '',
  intfType: 'HTTPS',
  tlsVersion: 'TLSv1.2',
  tlsType: 'Server',
  authenType: 'SIMPLE',
  privateKeyFile: '',
  passphrase: '',
  certificateFile: '',
  certificateAuthority: '',
  certificateDirectory: '',
  description: '',
  depth: '',
  hostname: '',
  cipherFile: '',
  sni: '',
  catype: 'SELFSIGNED',
  serialnumber: ''
};

export const distributorColumnDefs: ColDef[] = [
    {
      headerName: i18n.t('tlsProfile.form.field.catype'),
      field: 'catype',
      sortable: true,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      resizable: true,
      tooltipField: 'name',
      flex: 1,
      minWidth: 165,
    },
    {
      headerName: i18n.t('tlsProfile.form.field.id'),
      field: 'name',
      sortable: true,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      resizable: true,
      tooltipField: 'name',
      flex: 1,
    minWidth: 165,
    },
    {
      headerName: i18n.t('tlsProfile.grid.Description'),
      field: 'description',
      sortable: true,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      resizable: true,
      tooltipField: 'description',
      flex: 1,
      minWidth: 165,
    },
    {
      headerName: i18n.t('tlsProfile.grid.InterfaceType'),
      field: 'intfType',
      sortable: true,
      resizable: true,
      tooltipField: 'intfType',
      flex: 1,
      minWidth: 165,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
    },
    {
      headerName: i18n.t('tlsProfile.grid.TLSVersion'),
      field: 'tlsVersion',
      sortable: true,
      resizable: true,
      tooltipField: 'tlsVersion',
      flex: 1,
      minWidth: 165,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
    },
    {
      headerName: i18n.t('tlsProfile.grid.TLS'),
      field: 'tlsType',
      sortable: true,
      resizable: true,
      tooltipField: 'tlsType',
      flex: 1,
      minWidth: 165,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
    },
    {
      headerName: i18n.t('tlsProfile.grid.Authentication'),
      field: 'authenType',
      sortable: true,
      filter: 'agSetColumnFilter',
      floatingFilter: true,
      resizable: true,
      tooltipField: 'authenType',
      flex: 1,
      minWidth: 165,
      valueGetter: authenticationValueGetter,
    },
    {
      headerName: i18n.t('tlsProfile.grid.hostname'),
      field: 'hostname',
      sortable: true,
      filter: 'agSetColumnFilter',
      floatingFilter: true,
      resizable: true,
      tooltipField: 'hostname',
      flex: 1,
      minWidth: 165,
      valueGetter: authenticationValueGetter,
    },
    {
      headerName: i18n.t('tlsProfile.grid.certificateAuthority'),
      field: 'certificateAuthority',
      sortable: true,
      resizable: true,
      tooltipField: 'certificateAuthority',
      flex: 1,
      minWidth: 165,
      filter: 'agSetColumnFilter',
      floatingFilter: true,
    },
    {
      headerName: i18n.t('tlsProfile.grid.certificate'),
      field: 'certificateFile',
      sortable: true,
      resizable: true,
      tooltipField: 'certificateFile',
      flex: 1,
      minWidth: 165,
      filter: 'agSetColumnFilter',
      floatingFilter: true,
    },
    {
      headerName: i18n.t('tlsProfile.grid.certificateDirectory'),
      field: 'certificateDirectory',
      sortable: true,
      resizable: true,
      tooltipField: 'certificateDirectory',
      flex: 1,
      minWidth: 165,
      filter: 'agSetColumnFilter',
      floatingFilter: true,
    },
    {
      headerName: i18n.t('tlsProfile.grid.privateKeyFile'),
      field: 'privateKeyFile',
      sortable: true,
      resizable: true,
      tooltipField: 'privateKeyFile',
      flex: 1,
      minWidth: 165,
      filter: 'agSetColumnFilter',
      floatingFilter: true,
    },
];
